// Utils
import { find } from 'lodash';
import moment from 'moment';

import {
  Country,
  GetConferenceDetailsResult,
  PhoneType,
  TimeZone,
} from './types';

export const getInitialConferenceFields = (
  {
    id,
    districtId,
    relatedRotaryYear,
    startDate,
    startTime,
    endDate,
    endTime,
    venueName,
    language,
    prAccommodation,
    prComment,
    venueType,
    onlineLocation,
    detailForJoiningRemotely,
    conferenceAddress,
    prAddress,
    timeZone,
    isPresRepRequested,
    presRepAccPhone,
    participatingDistricts,
  }: GetConferenceDetailsResult,
  formattedCountries: Country[],
  defaultTimeZone: string,
  timeZones?: TimeZone[],
  hasStates?: boolean,
  prHasStates?: boolean
) => {
  const conferenceCountryValue =
    find(formattedCountries, ['countryName', conferenceAddress?.country])?.id ||
    '';
  const presRepCountryValue =
    find(formattedCountries, ['countryName', prAddress?.country])?.id || '';

  const predefinedTimeZone =
    find(timeZones, ['timeZoneName', timeZone])?.id || defaultTimeZone;

  const accomodationPhoneCountry =
    find(formattedCountries, ['id', presRepAccPhone?.countryId])?.countryName ||
    '';

  return {
    id,
    districtId,
    relatedRotaryYear,
    venueType,
    dateTime: {
      timeZone: predefinedTimeZone,
      startDate: startDate ? moment(startDate).toDate() : '',
      startTime: startTime || '',
      endDate: endDate ? moment(endDate).toDate() : '',
      endTime: endTime || '',
    },
    venueName: venueName || '',
    conferenceAddress: {
      city: conferenceAddress?.city || '',
      country: conferenceCountryValue,
      lineOne: conferenceAddress?.lineOne || '',
      lineTwo: conferenceAddress?.lineTwo || '',
      lineThree: conferenceAddress?.lineThree || '',
      postalCode: conferenceAddress?.postalCode || '',
      internationalProvince: conferenceAddress?.internationalProvince || '',
      state: conferenceAddress?.state || '',
      hasStates,
    },
    locationCityState: conferenceAddress?.city || '',
    locationCountry: conferenceCountryValue,
    language: language || '',
    prComment: prComment || '',
    participatingDistricts:
      participatingDistricts?.map(({ id, riDistrictId }) => ({
        id,
        value: riDistrictId,
      })) || null,
    onlineLocation: onlineLocation || '',
    detailForJoiningRemotely: detailForJoiningRemotely || '',
    prAddress: {
      city: prAddress?.city || '',
      country: presRepCountryValue || '',
      lineOne: prAddress?.lineOne || '',
      lineTwo: prAddress?.lineTwo || '',
      lineThree: prAddress?.lineThree || '',
      postalCode: prAddress?.postalCode || '',
      internationalProvince: prAddress?.internationalProvince || '',
      state: prAddress?.state || '',
      hasStates: prHasStates,
    },
    isPresRepRequested,
    accomodationPhone: {
      number: presRepAccPhone?.number || '',
      phoneType: PhoneType.Mobile,
      countryId: presRepAccPhone?.countryId || '',
      country: accomodationPhoneCountry,
      extension: accomodationPhoneCountry,
    },
    prAccommodation: prAccommodation || '',
  };
};
